// extracted by mini-css-extract-plugin
module.exports = {"multiSelectCrumbs":"Mx-z"};